import { Dialog } from 'primereact/dialog';
import classes from './BulkTmsModalUpload.module.scss';
import useBulkTmsModalUploadAndValidation from './useBulkTmsUploadAndValidationModa';
import DatavalidationComponent from './components/DataValidationComponent/DataValidationComponent';
import UploadComponent from 'components/uploadComponent/uploadComponent';

const BulkTmsUploadModal = ({
  visibility,
  toggleVisibility,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
}) => {
  const {
    fileUploaded,
    validationData,
    handleDownloadTemplate,
    isFileUploading,
    handleUploadFile,
  } = useBulkTmsModalUploadAndValidation();

  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      headerClassName={classes.modalHeader}
      header={fileUploaded ? `Data Validation` : ''}
      visible={visibility}
      style={{
        width: fileUploaded ? '90vw' : '30vw',
        maxHeight: '90vh',
        // overflow: "scroll",
        position: 'relative',
      }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
    >
      {!fileUploaded ? (
        <UploadComponent
          toggleVisibility={toggleVisibility}
          handleDownloadTemplate={handleDownloadTemplate}
          handleUploadFile={handleUploadFile}
          isFileUploading={isFileUploading}
        />
      ) : (
        <DatavalidationComponent data={validationData} successCallBack={toggleVisibility} />
      )}
    </Dialog>
  );
};

export default BulkTmsUploadModal;
